import React from 'react';
import {useTranslation} from 'react-i18next';
import {BellSlash} from '../icons';
import {Spinner} from '../Spinner';
import {formatFullMoney} from '../client/panel_v11/panelFormatters';
import {campaignKey} from './uncoveredSpend';

const RAW = {interpolation: {escapeValue: false}};

// Dónde puede partir renglón un nombre de campaña. Los nombres de las plataformas son tiras sin espacios
// («Prov_Diffu_LolitaLempicka_LP_Conversion_20261007»): sin un punto de corte, el navegador cortaba en
// cualquier letra y partía la fecha («202 / 61007»).
const NAME_BREAK_AFTER = /(?<=[_\-|/.])/;

/** El nombre con un `<wbr>` después de cada separador, para que corte ahí y no en medio de una palabra. */
export function breakableName(name) {
    const parts = String(name || '').split(NAME_BREAK_AFTER);
    return parts.map((part, index) => (
        <React.Fragment key={index}>{part}{index < parts.length - 1 && <wbr/>}</React.Fragment>
    ));
}

/**
 * Una campaña que no cuenta ninguna línea: nombre, monto y la campana de «No hace falta controlarla». La
 * comparten el popover de la línea y el de la cuenta.
 *
 * La campana va al final de la fila, con su nombre en un cartel al pasar el mouse o al llegar con Tab (en
 * pantallas táctiles va escrito, porque no hay hover). Escrito en cada fila competía con los nombres y los
 * montos, que son lo que se viene a leer; la nota del pie repite la campana junto al texto, para que el
 * ícono se entienda sin descubrirlo.
 */
export function UncoveredCampaignRow({campaign, busyKey, onDismiss}) {
    const {t} = useTranslation();
    const key = campaignKey(campaign);
    const dismissing = busyKey === `dismiss:${key}`;
    return (
        <li className="usp-pop__camp">
            <span className="usp-pop__camp-name">{breakableName(campaign.name)}</span>
            <span className="usp-pop__camp-amount">{formatFullMoney(campaign.currency, campaign.amount)}</span>
            <button type="button" className="usp-pop__dismiss" disabled={busyKey !== null} aria-busy={dismissing}
                    onClick={() => onDismiss(campaign)}
                    aria-label={t('line_uncovered.popover.dismiss_aria', {name: campaign.name, ...RAW})}>
                {dismissing ? <Spinner color="positive small"/> : <BellSlash size={14} weight="bold" aria-hidden="true"/>}
                <span className="usp-pop__dismiss-text" aria-hidden="true">{t('line_uncovered.popover.dismiss')}</span>
            </button>
        </li>
    );
}

export default UncoveredCampaignRow;
